var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { createLocalTracks, ParticipantEvent, Track, } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { proto3 } from '@bufbuild/protobuf';
import { isEmpty } from 'lodash';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveMicrophone, updateIsMicMuted, updateShowMicrophoneModal, } from '../../../store/slices/bottomIconsActivitySlice';
import MicMenu from './mic-menu';
import { participantsSelector } from '../../../store/slices/participantSlice';
import MicrophoneModal from '../modals/microphoneModal';
import { updateMuteOnStart } from '../../../store/slices/sessionSlice';
import { updateSelectedAudioDevice } from '../../../store/slices/roomSettingsSlice';
import { sendAnalyticsByWebsocket } from '../../../helpers/websocket';
import { AnalyticsEvents, AnalyticsEventType, AnalyticsStatus, } from '../../../helpers/proto/plugnmeet_analytics_pb';
import { getAudioPreset } from '../../../helpers/utils';
const isActiveMicrophoneSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveMicrophone);
$RefreshReg$(_react_refresh_temp_1, "isActiveMicrophoneSelector$createSelector");
const showMicrophoneModalSelector = createSelector(_react_refresh_temp_2 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.showMicrophoneModal);
$RefreshReg$(_react_refresh_temp_2, "showMicrophoneModalSelector$createSelector");
const isMicLockSelector = createSelector(_react_refresh_temp_3 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_microphone);
$RefreshReg$(_react_refresh_temp_3, "isMicLockSelector$createSelector");
const isMicMutedSelector = createSelector(_react_refresh_temp_4 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isMicMuted);
$RefreshReg$(_react_refresh_temp_4, "isMicMutedSelector$createSelector");
const MicrophoneIcon = ({ currentRoom }) => {
    var _a, _b;
    _react_refresh_temp_6();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const session = store.getState().session;
    const showTooltip = session.userDeviceType === 'desktop';
    const muteOnStart = (_b = (_a = session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.mute_on_start) !== null && _b !== void 0 ? _b : false;
    const showMicrophoneModal = useAppSelector(showMicrophoneModalSelector);
    const isActiveMicrophone = useAppSelector(isActiveMicrophoneSelector);
    const isMicLock = useAppSelector(isMicLockSelector);
    const isMicMuted = useAppSelector(isMicMutedSelector);
    const [lockMic, setLockMic] = useState(false);
    // for change in mic lock setting
    useEffect(() => {
        const closeMicOnLock = async () => {
            for (const [, publication,] of currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.audioTracks.entries()) {
                if (publication.track &&
                    publication.source === Track.Source.Microphone) {
                    await currentRoom.localParticipant.unpublishTrack(publication.track, true);
                }
            }
            dispatch(updateIsActiveMicrophone(false));
            dispatch(updateIsMicMuted(false));
        };
        if (isMicLock) {
            setLockMic(true);
            const currentUser = participantsSelector.selectById(store.getState(), currentRoom.localParticipant.identity);
            if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.audioTracks) {
                closeMicOnLock();
            }
        }
        else {
            setLockMic(false);
        }
    }, [isMicLock, currentRoom, dispatch]);
    // default room lock settings
    useEffect(() => {
        var _a, _b, _c, _d;
        const isLock = (_b = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.default_lock_settings) === null || _b === void 0 ? void 0 : _b.lock_microphone;
        const isAdmin = (_d = (_c = store.getState().session.currentUser) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.is_admin;
        if (isLock && !isAdmin) {
            if (isMicLock !== false) {
                setLockMic(true);
            }
        }
    }, []);
    // for speaking to send stats
    useEffect(() => {
        if (!currentRoom) {
            return;
        }
        const speakingHandler = (speaking) => {
            var _a;
            if (!speaking) {
                const lastSpokeAt = (_a = currentRoom.localParticipant.lastSpokeAt) === null || _a === void 0 ? void 0 : _a.getTime();
                if (lastSpokeAt && lastSpokeAt > 0) {
                    const cal = Date.now() - lastSpokeAt;
                    // send analytics
                    sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_TALKED_DURATION, AnalyticsEventType.USER, undefined, undefined, BigInt(cal));
                }
            }
            else {
                // send analytics as user has spoken
                sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_TALKED, AnalyticsEventType.USER, undefined, undefined, BigInt(1));
            }
        };
        currentRoom.localParticipant.on(ParticipantEvent.IsSpeakingChanged, speakingHandler);
        return () => {
            currentRoom.localParticipant.off(ParticipantEvent.IsSpeakingChanged, speakingHandler);
        };
    }, [currentRoom]);
    const muteUnmuteMic = async () => {
        for (const [, publication,] of currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.audioTracks.entries()) {
            if (publication.track &&
                publication.track.source === Track.Source.Microphone) {
                if (publication.isMuted) {
                    await publication.track.unmute();
                    dispatch(updateIsMicMuted(false));
                    // send analytics
                    sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_MIC_STATUS, AnalyticsEventType.USER, proto3.getEnumType(AnalyticsStatus).values[AnalyticsStatus.UNMUTED]
                        .name);
                }
                else {
                    await publication.track.mute();
                    dispatch(updateIsMicMuted(true));
                    // send analytics
                    sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_MIC_STATUS, AnalyticsEventType.USER, proto3.getEnumType(AnalyticsStatus).values[AnalyticsStatus.MUTED]
                        .name);
                }
            }
        }
    };
    const manageMic = async () => {
        if (!isActiveMicrophone && !lockMic) {
            dispatch(updateShowMicrophoneModal(true));
        }
        if (isActiveMicrophone) {
            await muteUnmuteMic();
        }
    };
    const getTooltipText = () => {
        if (!isActiveMicrophone && !lockMic) {
            return t('footer.icons.start-microphone-sharing');
        }
        else if (!isActiveMicrophone && lockMic) {
            return t('footer.icons.microphone-locked');
        }
        if (isActiveMicrophone && !isMicMuted) {
            return t('footer.menus.mute-microphone');
        }
        else if (isActiveMicrophone && isMicMuted) {
            return t('footer.menus.unmute-microphone');
        }
    };
    const onCloseMicrophoneModal = async (deviceId) => {
        dispatch(updateShowMicrophoneModal(false));
        if (isEmpty(deviceId)) {
            return;
        }
        const localTracks = await createLocalTracks({
            audio: {
                deviceId: deviceId,
            },
            video: false,
        });
        for (let i = 0; i < localTracks.length; i++) {
            const track = localTracks[i];
            if (track.kind === Track.Kind.Audio) {
                await (currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.publishTrack(track, {
                    audioPreset: getAudioPreset(),
                }));
                dispatch(updateIsActiveMicrophone(true));
            }
        }
        if (muteOnStart) {
            setTimeout(async () => {
                const audioTracks = currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.localParticipant.audioTracks;
                if (audioTracks) {
                    for (const [, publication] of audioTracks.entries()) {
                        if (publication.track &&
                            publication.track.source === Track.Source.Microphone) {
                            if (!publication.isMuted) {
                                await publication.track.mute();
                                dispatch(updateIsMicMuted(true));
                                // we'll disable it as it was first time only.
                                dispatch(updateMuteOnStart(false));
                            }
                        }
                    }
                }
            }, 500);
        }
        if (deviceId != null) {
            dispatch(updateSelectedAudioDevice(deviceId));
        }
    };
    return (_jsxs("div", { className: "relative z-10", children: [showMicrophoneModal ? (_jsx(MicrophoneModal, { show: showMicrophoneModal, onCloseMicrophoneModal: onCloseMicrophoneModal })) : null, _jsxs("div", { className: `microphone footer-icon relative h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => manageMic(), children: [_jsx("span", { className: "tooltip rtl:-left-3 rtl:microphone-rtl-left", children: getTooltipText() }), !isActiveMicrophone ? (_jsxs(_Fragment, { children: [_jsx("i", { className: "pnm-mic-unmute primaryColor dark:text-darkText text-[12px] lg:text-[14px]" }), lockMic ? (_jsx("div", { className: "arrow-down absolute -bottom-1 -right-1 w-[16px] h-[16px] rounded-full bg-white dark:bg-darkSecondary3 flex items-center justify-center", children: _jsx("i", { className: "pnm-lock primaryColor dark:text-darkText" }) })) : null] })) : null, !isMicMuted && isActiveMicrophone ? (_jsx("i", { className: "pnm-mic-unmute secondaryColor  text-[12px] lg:text-[14px]" })) : null, isMicMuted && isActiveMicrophone ? (_jsx("i", { className: "pnm-mic-mute secondaryColor text-[12px] lg:text-[14px]" })) : null] }), isActiveMicrophone ? _jsx(MicMenu, { currentRoom: currentRoom }) : null] }));
};
_react_refresh_temp_5 = MicrophoneIcon;
$RefreshReg$(_react_refresh_temp_5, "MicrophoneIcon");
_react_refresh_temp_6(MicrophoneIcon, "qvxO24rpQ64jvxxRMEK1hPH2dho=", false, () => [useAppDispatch, useTranslation, useAppSelector, useAppSelector, useAppSelector, useAppSelector]);
export default MicrophoneIcon;
